<template>
    <div class="innerBox">
        <h1>Master Data - Cat Brand</h1>

        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
                    <label for="partshopCode">Cari</label>
                    <input v-on:keyup.enter="vue_universal_table.update++"  type="text" class="form-control" placeholder="Ketik teks" style="height: 38px;" v-model="filter.search">
                </div>
                <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
                    <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
                </div>
                </div>
            </div>
        </panel>

        <div class="row mt-3 mb-3">
            <div class="col-sm-4 col-lg-2 offset-sm-8 offset-lg-10">
                <button
                    class="btn btn-outline-primary w-100"
                    @click="modal.addBrand = true"
                >
                    + Tambah Brand
                </button>
            </div>
        </div>

        <vue-universal-table
            :api_url="'/api/v1/masterData/cat-brand'"
            :filter="filter"
            :update="vue_universal_table.update"
            :sort_by="'created_at'"
            :sort_order="'ASC'"
            :fields="vue_universal_table.fields"
            :indexing="true"
        ></vue-universal-table>
        
        <addBrandModal 
            v-if="modal.addBrand"
            @closeModal="modal.addBrand = false"
            @refreshTable="
                vue_universal_table.update++;
                modal.addBrand = false;
            "
        />
    </div>


</template>

<script>
    import addBrandModal from './childComponents/addBrandModal.vue'

    export default {
        components : {
            addBrandModal
        },
        data () {
            return {
                mobile : this.isMobile(),
                filter : {
                search : ''
                },
                modal : {
                    addBrand : false
                },
                vue_universal_table : {
                    fields : [{
                        title : "Nama Brand",
                        variable : "brand_name"
                    }, {
                        title : 'Tanggal Dibuat',
                        variable : 'created_at',
                        date_format : 'MMM DD,Y HH:mm'
                    }],
                    update : 0,
                    special_button : ['']
                }
            }
        },
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
  .pt20{
    padding-top : 20px;
  }
</style>